<template>
  <div class="d-flex flex-column gap-12 mb-6" id="pdf">
    <!--  PART ONE  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> รายละเอียด
        </div>

        <!-- Form 1 -->
        <div class="d-flex flex-column gap-8">
          <!-- Form 1 #line1 -->
          <div class="d-flex gap-24">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="partOneValidate('department_name')">
            </ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">หน่วยงาน</div>
              <div>{{ masterData.formFund?.department_name }}</div>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div class="d-flex gap-24">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="partOneValidate('project_name_th')">
            </ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">ชื่อโครงการ(ไทย)</div>
              <div>{{ masterData.formFund?.project_name_th }}</div>
            </div>
          </div>

          <!-- Form 1 #line3 -->
          <div v-for="(m, ind) in masterData.formFund?.operating_activities" :key="ind" class="d-flex gap-24">
            <div v-if="!$route.query.preview" class="validate-ghost"></div>
            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">กิจกรรม {{ ind }}</div>
              <div>{{ m.activity }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-part">
        <!-- Form 1 Part 2 -->
        <div class="d-flex flex-column gap-8">
          <!-- Form 1 Part 2 #line1 -->
          <div class="d-flex gap-24">
            <div class="font-type-bold black--text mb-3">2.ผู้รายงานผล</div>
          </div>

          <!-- Form 1 Part 2 #line2 -->
          <div class="d-flex gap-24">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="partOneValidate('reporter_name')"></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">ชื่อผู้รายงาน</div>
              <div>{{ masterData.formFund?.reporter_name }}</div>
            </div>
          </div>

          <!-- Form 1 Part 2 #line3 -->
          <div class="d-flex gap-24">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="partOneValidate('position')"></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">ตำแหน่ง</div>
              <div>{{ masterData.formFund?.position }}</div>
            </div>
          </div>

          <!-- Form 1 Part 2 #line4 -->
          <div class="d-flex gap-24">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="partOneValidate('department')"></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">สังกัด</div>
              <div>{{ masterData.formFund?.department }}</div>
            </div>
          </div>

          <div class="d-flex gap-24">


            <div class="d-flex gap-16"
            :class="{
              'ml-12': !$route.query.preview
            }"
            >
              <div class="mb-1 black--text topic-field">หมายเลขโทรศัพท์</div>
              <div>{{ masterData.formFund?.mobile_phone }}</div>
            </div>
          </div>

          <div class="d-flex gap-24">


            <div class="d-flex gap-16"
            :class="{
              'ml-12': !$route.query.preview
            }"
            >
              <div class="mb-1 black--text topic-field">โทรสาร</div>
              <div>{{ masterData.formFund?.fax }}</div>
            </div>
          </div>

          <!-- Form 1 Part 2 #line7 -->
          <div class="d-flex gap-24">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="partOneValidate('email')"></ValidatorIcon>

            <div class="d-flex gap-16">
              <div class="mb-1 black--text topic-field">อีเมล์</div>
              <div>{{ masterData.formFund?.email }}</div>
            </div>
          </div>
        </div>
      </div>
    </divcard>

    <!--  PART TWO  -->
    <divcard titled>
      <div class="card-part py-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 2 :</span>
          วงเงินที่ได้รับอนุมัติและสถานะการดำเนินโครงการ
        </div>

        <!-- line1 -->
        <div class="d-flex gap-24">
          <ValidatorIcon v-if="!$route.query.preview" :is-correct="partTwoValidate('form_fund_budgets')">
          </ValidatorIcon>
          <div class="font-type-bold black--text mb-2 txt-bigger2">
            วงเงินที่ได้รับอนุมัติและงบประมาณที่ใช้จ่ายจริง
          </div>
        </div>
        <!-- Form 1 -->
        <div v-if="masterData.formFund.form_fund_budgets" class="d-flex flex-column gap-8">
          <!-- Form 1 #loop -->
          <!-- header -->
          <div class="card-part">
            <div class="d-flex theme-color-eight mb-3 gap-12">
              <div class="d-flex gap-24" style="width: 20%">
                <div v-if="!$route.query.preview" class="validate-ghost"></div>
                รายการ
              </div>
              <div style="width: 32%">รายละเอียด</div>
              <div class="text-end" style="width: 24%">
                ค่าใช้จ่ายจริง (บาท)
              </div>
              <div class="text-end" style="width: 24%">
                กรอบวงเงินงบประมาณ(บาท)
              </div>
            </div>
            <div class="d-flex flex-column gap-16">
              <div v-for="(item, i) in masterData.formFund.form_fund_budgets" :key="i" class="budget-item">
                <div class="d-flex justify-space-between align-center black--text gap-12">
                  <div class="d-flex gap-24" style="width: 20%">
                    <div v-if="!$route.query.preview" class="validate-ghost"></div>
                    {{ item.budget_name }}
                  </div>
                  <div style="width: 32%">
                    <div style="min-height: 22px; max-height: 22px"></div>
                    <div>
                      <div v-for="(detail, ind) in item.form_fund_budget_detail" :key="ind" class="theme-color-eight">
                        {{ ind + 1 }}. {{ detail.budget_detail_name }}
                      </div>
                    </div>
                  </div>
                  <div class="text-end" style="width: 24%">
                    {{ formatNumber(item.actual_amount, 2) }} บาท
                    <div>
                      <div v-for="(detail, ind) in item.form_fund_budget_detail" :key="ind"
                        class="text-end theme-color-eight">
                        {{ formatNumber(detail.actual_detail_amount, 2) }} บาท
                      </div>
                    </div>
                  </div>
                  <div class="text-end" style="width: 24%">
                    {{ formatNumber(item.net_fund_budget, 2) }} บาท
                    <div>
                      <div v-for="(detail, ind) in item.form_fund_budget_detail" :key="ind"
                        class="text-end theme-color-eight">
                        {{ formatNumber(detail.budget_detail_amount, 2) }} บาท
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Form 1 #net -->
          <div class="d-flex flex-column gap-12 card-part mt-3 mb-0 py-0 pb-6">
            <div class="d-flex justify-space-between">
              <div class="d-flex gap-24 black--text">
                <div v-if="!$route.query.preview" class="validate-ghost"></div>
                รวมวงเงินงบประมาณ
              </div>
              <div>
                {{
                  formatNumber(
                    masterData.formFund.form_fund_budgets
                      .map((x) => parseFloat(x.net_fund_budget))
                      .reduce((a, b) => a + b, 0),
                    2
                  )
                }}
                บาท
              </div>
            </div>
          </div>
          <div class="d-flex flex-column gap-12 card-part mt-3 mb-0 py-0 pb-6">
            <div class="d-flex justify-space-between">
              <div class="d-flex gap-24 black--text">
                <div v-if="!$route.query.preview" class="validate-ghost"></div>
                รวมค่าใช้จ่ายต่อเดือน
              </div>
              <div>
                {{
                  formatNumber(
                    masterData.formFund.form_fund_budgets
                      .map((x) => parseFloat(x.actual_amount))
                      .reduce((a, b) => a + b, 0),
                    2
                  )
                }}
                บาท
              </div>
            </div>
          </div>
          <div class="d-flex flex-column gap-12 card-part mt-3 mb-0 py-0 pb-6">
            <div class="d-flex justify-space-between">
              <div class="d-flex gap-24 black--text">
                <div v-if="!$route.query.preview" class="validate-ghost"></div>
                คงเหลือ
              </div>
              <div class="theme-color-one">
                {{
                  formatNumber(
                    masterData.formFund.form_fund_budgets
                      .map((x) => parseFloat(x.net_fund_budget))
                      .reduce((a, b) => a + b, 0) -
                    masterData.formFund.form_fund_budgets
                      .map((x) => parseFloat(x.actual_amount))
                      .reduce((a, b) => a + b, 0),
                    2
                  )
                }}
                บาท
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form 2 -->
      <div class="card-part">
        <!-- line1 -->
        <div class="d-flex gap-24">
          <ValidatorIcon v-if="!$route.query.preview" :is-correct="partTwoValidate('project_status')"></ValidatorIcon>
          <div class="font-type-bold black--text mb-2 txt-bigger2">
            สถานะการดำเนินโครงการ
          </div>
        </div>
        <div class="d-flex gap-24">
          <div v-if="!$route.query.preview" class="validate-ghost"></div>
          <div class="font-type-bold black--text mb-2">
            {{ masterData.formFund?.project_status || "-" }}
          </div>
        </div>
      </div>
    </divcard>

    <!--  PART THREE  -->
    <divcard titled>
      <div class="card-part pt-0 s3-p1-h">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 3 :</span> แผนการดำเนินงาน
        </div>

        <!-- Form 1 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="partThreeValidate('fund_budgets')"></ValidatorIcon>
            <div class="font-type-bold black--text">1.ผลการดำเนินโครงการ</div>
          </div>

          <!--  TABLE   -->
          <div class="budget-table-container">
            <table class="budget-table">
              <thead>
                <tr>
                  <th rowspan="2">กิจกรรม (ตามโครงการที่ได้รับอนุมัติ)</th>
                  <th colspan="3">งบประมาณที่ใช้</th>
                  <th rowspan="2">หมายเหตุ</th>
                </tr>
                <tr>
                  <th style="width: 12%">ได้รับอนุมัติ</th>
                  <th>เบิกจ่ายแล้ว</th>
                  <th>คงเหลือ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in masterData.formFund?.fund_budgets" :key="item.id">
                  <td>
                    <div class="activity-content">
                      <!-- Main activity -->
                      <div class="activity-section">
                        <div class="activity-number">
                          {{ index + 1 + ".1 " + item.budget_name }}
                        </div>
                        <div class="activity-description" v-if="item.budget_detail">
                          {{ item.budget_detail }}
                        </div>
                      </div>

                      <!-- Procedure section -->
                      <div class="activity-section" v-if="item.procedure">
                        <div class="activity-number">
                          {{ index + 1 + ".2 วิธีการดำเนินการ" }}
                        </div>
                        <div class="activity-description">
                          - {{ item.procedure }}
                        </div>
                      </div>

                      <!-- Result section -->
                      <div class="activity-section" v-if="item.result">
                        <div class="activity-number">
                          {{ index + 1 + ".3 ผลการดำเนินงาน" }}
                        </div>
                        <div class="activity-description">
                          - {{ item.result }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="amount">{{ item.approved_budget }}</td>
                  <td class="amount">{{ item.disbursed_budget }}</td>
                  <td class="amount">{{ item.remaining_budget }}</td>
                  <td>{{ item.remarks }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="card-part s3-p1-h">
        <!-- Form 2 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="partThreeValidate('section_plans')">
            </ValidatorIcon>
            <div class="font-type-bold black--text">2.ร้อยละการดำเนินงาน</div>
          </div>

          <!--   PLAN HEADERS   -->
          <div class="py-5 overflow-x-auto mx-n6 px-6 scroll s3-p1">
            <div class="d-flex justify-space-between gap-8 px-3 mb-3">
              <div class="flex" style="min-width: 120px; max-width: 120px">
                กิจกรรม
              </div>
              <!-- <div class="flex" style="min-width: 61px; max-width: 61px">
                  WF
                </div> -->
              <div v-for="(m, ind) in shortMonths" :key="ind" class="flex" style="min-width: 43px; max-width: 43px">
                <div class="text-center">{{ m.month }}</div>
                <div class="text-center">{{ m.year }}</div>
              </div>
              <div class="flex" style="min-width: 43px; max-width: 43px">
                แผนผล
              </div>
              <div class="flex text-center" style="min-width: 43px; max-width: 43px">
                %
              </div>
            </div>

            <!--   PLAN ITEMS   -->
            <div v-if="partThreeAllPlans && partThreeAllPlans.length > 0" class="d-flex flex-column gap-12">
              <div v-for="(item, i) in partThreeAllPlans" :key="i"
                class="plan-card d-flex justify-space-between gap-8 no-box-shadow">
                <div class="d-block">
                  <div class="flex two-line" style="min-width: 120px; max-width: 120px; max-height: 45px">
                    <!-- {{ item.p1_activity_name }} -->
                    <tooltip-text :text="item.p1_activity_name" />
                  </div>
                </div>
                <!-- <div
                    class="flex d-flex justify-space-between"
                    style="min-width: 61px; max-width: 61px; height: 54px"
                  >
                    <v-divider vertical></v-divider>
                    <div
                      class="tiny-field tf-active"
                      style="min-width: 40px; max-width: 40px; height: 100%"
                    >
                      {{ item.p1_wf }}
                    </div>
                    <v-divider vertical></v-divider>
                  </div> -->
                <div v-for="(m, ind) in item.project_section_plan_month" :key="ind"
                  class="flex d-flex flex-column gap-8" style="min-width: 43px; max-width: 43px">
                  <div class="tiny-field">
                    {{ m.month_value ? m.month_value : "-" }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{ m.actual_month_value ? m.actual_month_value : "-" }}
                  </div>
                </div>
                <div class="flex d-flex flex-column gap-8" style="min-width: 43px; max-width: 43px">
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]?.month_value ||
                      "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      item.project_section_plan_month[currIndex]
                        ?.actual_month_value || "-"
                    }}
                  </div>
                </div>
                <div class="flex d-flex flex-column gap-8" style="min-width: 43px; max-width: 43px">
                  <div class="tiny-field">
                    {{
                      item.project_section_plan_month[shortMonths.length - 1]
                        ?.month_value || "-"
                    }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{
                      formatNumber(
                        parseFloat(
                          item.project_section_plan_month[currIndex]
                            ?.actual_month_value * 100
                        ) /
                        parseFloat(
                          item.project_section_plan_month[currIndex]
                            ?.month_value
                        ),
                        2
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
        </div>
      </div>
    </divcard>

    <!--  PART FOUR  -->
    <divcard titled>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 4 :</span>
          การประเมินผลสำเร็จของโครงการ
        </div>

        <!-- Form 1 -->
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="partFourValidate('section_one')"></ValidatorIcon>
            <div class="font-type-bold black--text">1. ผลสำเร็จของโครงการ</div>
          </div>

          <div class="d-flex flex-column gap-8">
            <div class="d-flex flex-column gap-4">
              <!-- Form 1 #line1 -->
              <div class="d-flex gap-24">
                <div v-if="!$route.query.preview" class="validate-ghost"></div>
                <div class="black--text topic-field">ประเมินผล</div>
              </div>
              <!-- Form 1 #line2 -->
              <div class="d-flex gap-24">
                <div v-if="!$route.query.preview" class="validate-ghost"></div>
                <div class="black--text topic-field w-100 max-w-100">
                  {{ masterData.formFund?.evaluate_by || "-" }}
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-4">
              <!-- Form 1 #line3 -->
              <div class="d-flex gap-24">
                <div v-if="!$route.query.preview" class="validate-ghost"></div>
                <div class="black--text topic-field">ผลประเมิน (ถ้ามี)</div>
              </div>
              <!-- Form 1 #line4 -->
              <div class="d-flex gap-24">
                <div v-if="!$route.query.preview" class="validate-ghost"></div>
                <div class="black--text topic-field w-100 max-w-100">
                  {{ masterData.formFund?.evaluate_detail || "-" }}
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-4">
              <!-- Form 1 #line5 -->
              <div class="d-flex gap-24">
                <div v-if="!$route.query.preview" class="validate-ghost"></div>
                <div class="black--text topic-field w-100 max-w-100">
                  ร้อยละความพึงพอใจของผู้รับบริการ
                </div>
              </div>
              <!-- Form 1 #line6 -->
              <div class="d-flex gap-24">
                <div v-if="!$route.query.preview" class="validate-ghost"></div>
                <div class="black--text topic-field">
                  {{ masterData.formFund.satisfaction ? "มี" : "ไม่มี" }}
                </div>
              </div>
            </div>
            <div class="d-flex flex-column gap-4">
              <div class="d-flex gap-24">
                <!-- Form 1 #line5 -->
                <div v-if="!$route.query.preview" class="validate-ghost"></div>
                <div class="black--text topic-field">ผลประเมิน (ถ้ามี)</div>
              </div>
              <div class="d-flex gap-24">
                <!-- Form 1 #line6 -->
                <div v-if="!$route.query.preview" class="validate-ghost"></div>
                <div class="black--text topic-field w-100 max-w-100">
                  {{ masterData.formFund?.satisfaction_detail || "-" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form 2 -->
      <div class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="partFourValidate('problem')"></ValidatorIcon>
            <div class="font-type-bold black--text">
              2. ปัญหาและอุปสรรคการดำเนินโครงการ
            </div>
          </div>

          <div class="d-flex gap-24">
            <div v-if="!$route.query.preview" class="validate-ghost"></div>
            <div v-html="masterData.formFund?.problem?.replace(/\n/g, '<br>')"></div>
          </div>
        </div>
      </div>

      <!-- Form 3 -->
      <div class="card-part">
        <div>
          <div class="d-flex align-center gap-24 mb-3">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="partFourValidate('recommendation')">
            </ValidatorIcon>
            <div class="font-type-bold black--text">
              3. ข้อสังเกต ข้อเสนอแนะ และประเด็นที่ต้องติดตาม
            </div>
          </div>

          <div class="d-flex gap-24">
            <div v-if="!$route.query.preview" class="validate-ghost"></div>
            <div v-html="masterData.formFund?.recommendation?.replace(/\n/g, '<br>')
              "></div>
          </div>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import {
  eventBus,
  formatNumber,
  validateEmail,
} from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import OOILineField from "../../../components/OOILineField";
import ValidatorIcon from "../../../components/ValidatorIcon";
import { format } from "date-fns";
import { th } from "date-fns/locale";
import { apiDomain } from "@/store/constants";
import axios from "axios";

export default {
  name: "BFormSummary",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    OOILineField,
    ValidatorIcon,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      partOneForm: {},
      partTwoForm: {},
      shortMonths: [],
      partThreeForm: {},
      partThreeAllPlans: [],
      partThreeBudgetList: [],
      partThreeBudgetPlans: [],
      partThreeAllProgressPlan: [],
      partFourForm: {},
      kpi: {},
      annexProjects: [],
      partFiveAttachment: [],
      OAList: [],
      kpi_annex_projects: [],
      ableToSubmit: true,
      exceptShowKPINo: ["20.1", "20.2", "20.3", "20.4", ""],
      mockFormfundBugdetDetail: [
        {
          budget_name: "งบประมาณดำเนินงาน1",
          net_fund_budget: 5000000,
          have_budget_detail: false,
          form_fund_budget_detail: [],
        },
        {
          budget_name: "งบประมาณดำเนินงาน2",
          net_fund_budget: 1000000,
          have_budget_detail: true,
          form_fund_budget_detail: [
            {
              budget_detail_name: "ค่าใช้จ่ายบุคลากร",
              budget_detail_amount: 500000,
            },
            {
              budget_detail_name: "ค่าใช้จ่ายทั่วไป",
              budget_detail_amount: 300000,
            },
            {
              budget_detail_name: "ค่าใช้จ่ายอื่นๆ",
              budget_detail_amount: 200000,
            },
          ],
        },
      ],
      netAllBudget: 0,
    };
  },
  computed: {
    ...mapState({
      userRole: (state) => state.Auth.User.user_type,
      user: (state) => state.Auth.User,
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  async created() {
    console.log("masterData sum", this.masterData);
    this.ableToSubmit = true;
    this.getNetAllBudget();
    this.fiscalYear = this.masterData.formFund?.fiscal_year;
    //   // PART THREE
    this.setupBudgetYearMonth();
    this.partThreeAllPlans =
      this.masterData.formFund?.project_section_plan.project_plan_p1;
    this.partThreeBudgetPlans =
      this.masterData.formFund.project_section_plan
        .project_section_plan_p1_budget || [];
    this.currIndex = this.getCurrIndex();

    console.log("partThreeAllPlans", this.partThreeAllPlans);
  },
  methods: {
    getCurrIndex() {
      let ind = 0;
      for (const x of this.partThreeAllPlans) {
        let i = 0;
        for (const y of x.project_section_plan_month) {
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean") return correctIndex;
          i++;
        }
        ind++;
      }
    },
    isInCorrectRange(item, index = null) {
      let today = new Date();
      let currentMonth = today.getMonth();
      let thisMonth = new Date(item.year_month).getMonth();

      let isCorrectCase = thisMonth === currentMonth;

      // for return active yearMonth index
      if (isCorrectCase && index !== null) return index;

      return isCorrectCase;
    },
    setupBudgetYearMonth() {
      if (!this.fiscalYear) {
        this.fiscalYear = new Date().getFullYear() + 543;
      }

      let ym = new Date((this.fiscalYear - 544).toString() + "-10");
      for (let i = 0; i < 12; i++) {
        this.shortMonths.push({
          key: i + 1,
          month: format(ym, "MMM", { locale: th }),
          year: (parseInt(ym.toISOString().substr(0, 7).split("-")[0]) + 543)
            .toString()
            .slice(2),
        });
        ym = new Date(ym.setMonth(ym.getMonth() + 1));
      }
    },
    allowFormAbleSubmit(isCorrect) {
      if (!isCorrect) {
        this.ableToSubmit = false;
      }
      eventBus.$emit("fundamentalFormAbleToSubmit", this.ableToSubmit);
    },

    partOneValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "department_name":
          if (!this.masterData.formFund.department_name) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "project_name_th":
          if (!this.masterData.formFund.project_name_th) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "reporter_name":
          if (!this.masterData.formFund.reporter_name) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "position":
          if (!this.masterData.formFund.position) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "department":
          if (!this.masterData.formFund.department) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "mobile_phone":
          if (
            !this.masterData.formFund.mobile_phone
          ) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "fax":
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "email":
          if (!validateEmail(this.masterData.formFund.email)) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    partTwoValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "form_fund_budgets":
          if (
            !this.masterData.formFund.form_fund_budgets ||
            this.masterData.formFund.form_fund_budgets.length < 1
          ) {
            isCorrect = false;
          } else {
            this.masterData.formFund.form_fund_budgets.forEach((budget) => {
              if (
                !budget.budget_name ||
                budget.budget_name.trim() === "" ||
                !budget.net_fund_budget ||
                budget.net_fund_budget <= 0
              ) {
                isCorrect = false;
              }
            });
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "project_status":
          if (!this.masterData.formFund.project_status) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    partThreeValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "fund_budgets":
          if (
            !this.masterData.formFund.fund_budgets ||
            this.masterData.formFund.fund_budgets.length < 1
          ) {
            isCorrect = false;
          } else {
            this.masterData.formFund.fund_budgets.forEach((budget) => {
              if (
                !budget.budget_name ||
                budget.budget_name.trim() === "" ||
                !budget.approved_budget ||
                budget.approved_budget <= 0
              ) {
                isCorrect = false;
              }
            });
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "section_plans":
          if (
            !this.masterData.formFund.project_section_plan ||
            !this.masterData.formFund.project_section_plan.project_plan_p1 ||
            this.masterData.formFund.project_section_plan.project_plan_p1
              .length < 1
          ) {
            isCorrect = false;
          } else {
            if (
              this.masterData.formFund.project_section_plan &&
              this.masterData.formFund.project_section_plan.project_plan_p1 &&
              Array.isArray(
                this.masterData.formFund.project_section_plan.project_plan_p1
              )
            ) {
              this.masterData.formFund.project_section_plan.project_plan_p1.forEach(
                (plan) => {
                  if (
                    !plan.p1_activity_name ||
                    plan.p1_activity_name.trim() === ""
                  ) {
                    isCorrect = false;
                  }
                }
              );
            }
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    partFourValidate(section) {
      let isCorrect = true;
      switch (section) {
        case "section_one":
          if (!this.masterData.formFund.evaluate_by) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "problem":
          if (
            !this.masterData.formFund.problem ||
            this.masterData.formFund.problem.trim() === ""
          ) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;

        case "recommendation":
          if (
            !this.masterData.formFund.recommendation ||
            this.masterData.formFund.recommendation.trim() === ""
          ) {
            isCorrect = false;
          }
          this.allowFormAbleSubmit(isCorrect);
          return isCorrect;
      }
    },
    getNetAllBudget() {
      if (!this.masterData || !this.masterData.formFund) {
        this.netAllBudget = 0;
        return;
      }

      const budgets = this.masterData.formFund.form_fund_budgets;

      if (!budgets.length) {
        this.netAllBudget = 0;
        return;
      }

      const firstBudget = parseFloat(budgets[0].net_fund_budget) || 0;

      const restTotal = budgets.slice(1).reduce((acc, budget) => {
        const netBudget = parseFloat(budget.net_fund_budget) || 0;
        return acc - netBudget;
      }, firstBudget);

      this.netAllBudget = restTotal;
    },
  },
};
</script>

<style scoped lang="scss">
.summary-plan {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #fafafa;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: "Tahoma", sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
.topic-field {
  min-width: 160px;
  max-width: 160px;
}
.indent-info {
  padding-left: 85px;
}
.w-100 {
  width: 100%;
}
.w-5 {
  width: 5%;
}
.max-w-100 {
  max-width: 100%;
}

.budget-table-container {
  border: 1px solid #ddd;
  border-radius: 12px;
  overflow: hidden;
  margin: 20px 0;
  font-size: 14px;
  background-color: white;
}

.budget-table {
  width: 100%;
  border-collapse: collapse;
  border: none;
}

.budget-table th,
.budget-table td {
  border: 1px solid #ddd;
  padding: 12px 8px;
  vertical-align: top;
  text-align: left;
}

/* Remove outer borders only */
.budget-table th:first-child,
.budget-table td:first-child {
  border-left: none;
}

.budget-table th:last-child,
.budget-table td:last-child {
  border-right: none;
}

.budget-table thead tr:first-child th {
  border-top: none;
}

.budget-table tbody tr:last-child td {
  border-bottom: none;
}

.budget-table th {
  background-color: white;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}

/* Activity content styling */
.activity-content {
  padding: 0;
}

.activity-section {
  margin-bottom: 8px;
}

.activity-section:last-child {
  margin-bottom: 0;
}

.activity-number {
  font-weight: 500;
  margin-bottom: 2px;
  color: black;
}

.activity-description {
  font-size: 13px;
  color: black;
  line-height: 1.4;
  margin-left: 0;
  word-wrap: break-word;
  word-break: break-word;
}

/* Remove old styling */
.main-activity {
  background-color: white;
}

.sub-activity {
  background-color: white;
}

.activity-title {
  font-weight: normal;
}

.budget-detail,
.procedure-text,
.result-text,
.sub-activity-title {
  display: none;
}

/* Column widths */
.budget-table th:first-child,
.budget-table td:first-child {
  width: 50%;
}

.budget-table th:nth-child(2),
.budget-table td:nth-child(2),
.budget-table th:nth-child(3),
.budget-table td:nth-child(3),
.budget-table th:nth-child(4),
.budget-table td:nth-child(4) {
  width: 12%;
  text-align: center;
  padding-right: 12px;
}

.budget-table th:last-child {
  width: 14%;
  text-align: center;
}
.budget-table td:last-child {
  width: 14%;
  text-align: start;
  word-wrap: break-word;
  word-break: break-word;
}

.amount {
  font-weight: 500;
}

.validate-ghost {
  min-width: 24px;
}
</style>
